import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// date-fns format string, day-month-year, e.g. "24 September 2026"
export const DISPLAY_DATE_FORMAT = "d MMMM yyyy"

// Auth0 prefixes a user_id with its connection/strategy, e.g. "auth0|abc123"
// (Username-Password-Authentication) or "google-oauth2|abc123" (Google).
// Same prefix convention already relied on in auth0-repository.ts/user-form.tsx.
export function getLoginMethodLabel(userId: string): string {
  if (userId.startsWith("google-oauth2|")) return "Google";
  if (userId.startsWith("auth0|")) return "Username & Password";
  const [provider] = userId.split("|");
  return provider || "Unknown";
}
